export const PARAMETER_PADDING = '0rem 1rem 0 2rem';
export const COMMENT_PADDING = '0rem 2rem 0 1rem';
